import type { DataAvailabilityPreviewState } from "@store/slices/data-availability-preview-slice";

/** Returns the preview date when an active preview applies to this dashboard
 *  (and dataset, when provided); otherwise returns the dataset's real availability date. */
export function getEffectiveAvailabilityDate(
  realAvailabilityDate: string | null | undefined,
  preview: DataAvailabilityPreviewState,
  dashboardId: string | null | undefined,
  datasetId?: string | null,
): string | null {
  const isActiveForDashboard =
    preview.isActive &&
    !!dashboardId &&
    preview.dashboardId === dashboardId &&
    (datasetId === undefined || preview.datasetId === datasetId);

  if (isActiveForDashboard) {
    return preview.previewDate;
  }
  return realAvailabilityDate ?? null;
}
